import { render } from "./FillInformation.vue?vue&type=template&id=72ffefe8"
import script from "./FillInformation.vue?vue&type=script&lang=js"
export * from "./FillInformation.vue?vue&type=script&lang=js"

import exportComponent from "/builds/nordhealth/projects/therapy/easypractice/system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__